import * as types from './page-state.types';

export const pageStateSelectors: types.IPageStateSelectors = {
  selectPageInProgress: (state, key) => state.page.pageState[key].inProgress,
  selectPageError: (state, key) => state.page.pageState[key].error,
  selectPageStates: (state) => state.page.pageState,
};
